<div id="promo-wrapper">
    <section id="promo" class="mt-4 mb-4">
        <div class="container dark">

            <header>
                <h2 i18n>Unser Tech-Blog – Aktuelle und interessante Themen rund um unsere Arbeit</h2>
            </header>

            <p i18n>In unserem Tech-Blog teilen wir spannende Einblicke in die Welt der IT, aktuelle Trends und hilfreiche Tipps aus unserer täglichen Arbeit. Ob es um innovative
                Softwarelösungen, Best Practices bei der Digitalisierung oder Erfahrungsberichte aus erfolgreichen Projekten geht – hier finden Sie regelmäßig neue Artikel, die Sie
                auf dem Laufenden halten. Schauen Sie vorbei und entdecken Sie, wie wir Technologien einsetzen, um Unternehmen effizienter und zukunftssicher zu machen.</p>

        </div>
    </section>
</div>

<router-outlet></router-outlet>